export const locale = {
    lang: 'es',
    data: {
      'MODALES': {
        'VALIDACION':{
          'ERROR1':'Aún tienen preguntas sin traducir'
        },
        'TITULO': 'Ocurrió un error',
        'TITULOS': {
          'error': 'Ocurrió un error',
          'adver': 'Advertencia',
          'aviso': 'Aviso',
          'opSuc': 'Acción completada'
        },
        'ACCIONES': {
          'aceptar' : 'Aceptar',
          'cancelar': 'Cancelar',
          'INFORMATIVO': 'No volver a mostrar mensaje'
        },
        'EXPEDIENTES':{
          'Resultados': 'Aún no se cuenta con los resultados de la encuesta',
          'CARGANDO_COLABORADORES':'Cargando colaboradores que necesitan seguimiento médico',
        },
        'MENSAJES': {
          'Something is wrong': 'Algo está mal',
          'password wrong': 'La contraseña introducida es incorrecta',
          'User does not exist': 'El correo introducido no está registrado',
          '150': 'Se insertaron los colaboradores',
          'Error: user already exist': 'El usuario que intenta registrar ya existe',
          'CONEX': {
            'SIN': 'Su equipo ha perdido la conexión a internet\n\nPara continuar utilizando la plataforma, conecte su equipo a internet',
            'CON': 'Su equipo ha recuperado la conexión a internet\n\nAhora puede continuar utilizando la plataforma'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'Para acceder a esta sección es necesario que elija los <b>idiomas</b> para la encuesta',
                'rest2': 'Para acceder a esta sección es necesario que complete todos los pasos anteriores',
                'rest3': 'Para acceder a esta sección es necesario que complete la <b>programación de la encuesta</b>',
                'rest4': 'Para acceder a esta sección es necesario que haya realizado el <b>envío de correos</b> a sus colaboradores y que la encuesta haya sido lanzada',
                'rest5': 'Para acceder a esta sección es necesario que configure los <b>Demográficos</b> para la encuesta'
              },
              'IDIOMAS': {
                'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                '210': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se elige el idioma principal e idiomas adicionales en los que se presentará la encuesta al colaborador',
                'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación.',
                'BOTONTEXTO':'Enterado',
              },
              'NPS': {
                'NADA': 'No ha creado ningun NPS o marcado la opción sin NPS',
                'COMPLETAR': '¿Está seguro de completar el paso con sus NPS actuales?',
                '219': 'El paso se completó correctamente',
                '220': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden modificar sus NPS para la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de sus NPS'
              },
              'REACTIVOS': {
                'NADA': 'No ha creado ningun reactivo o marcado la opción sin reactivos',
                'COMPLETAR': '¿Está seguro de completar el paso con los reactivos introducidos actualmente?',
                '218': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar reactivos a la encuesta',
                'FALTANTES': 'Aun no ha completado el llenado de sus reactivos'
              },
              'FORALL': {
                'NADA': 'Aún no ha completado el llenado de prácticas 4ALL',
                'COMPLETAR': '¿Está seguro de completar el paso con las prácticas 4ALL introducidas actualmente?',
                '212': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se enlistan las actividades que se realizan en la empresa, mismas que involucran la participación de todos los colaboradores',
                'NADA_TRA': 'Aún no has completado las traducciones de las prácticas 4ALL',
              },
              'CONTROL': {
                'NADA': 'No ha creado ninguna pregunta de control o marcado la opción sin control',
                'COMPLETAR': '¿Está seguro de completar el paso con su pregunta de control actual?',
                '221': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se puede modificar su pregunta de control para la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de su pregunta de control'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Aún no ha seleccionado demográficos',
                'COMPLETAR': '¿Está seguro de completar el paso con la información de demográficos introducida actualmente?',
                '213': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se establecen las opciones demográficas que serán puestas a disposición del colaborador en la encuesta'
              },
              'ABIERTAS': {
                'NADA': 'No ha creado ninguna pregunta abierta o marcado la opción sin preguntas abiertas',
                'COMPLETAR': '¿Está seguro de completar el paso con las preguntas abiertas introducidas actualmente?',
                '220': 'El paso se completó correctamente',
                '219': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar preguntas abiertas a la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de sus preguntas abiertas'
              },
              'ADICIONALES': {
                'NADA': 'No ha creado ninguna pregunta adicional o marcado la opción sin preguntas adicionales',
                'COMPLETAR': '¿Está seguro de completar el paso con las preguntas adicionales introducidas actualmente?',
                '214': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar preguntas personalizadas a la encuesta'
              },
              'COLABORADORES': {
                'NADA': 'Aún no ha cargado la información de sus colaboradores',
                'COMPLETAR': '¿Está seguro de completar el paso con la lista de colaboradores cargada actualmente?',
                '211': 'El paso se completó correctamente',
                '200': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se carga la lista de colaboradores a los que se les enviará la invitación a la encuesta vía correo electrónico',
                'ACTUALIZAR': 'Se agregaron correctamente los colaboradores a la encuesta'
              },
              'PROGRAMACION': {
                'NADA': 'Aún no ha programado fechas',
                'NADA1': 'Aún no ha programado fecha de lanzamiento',
                'NADA2': 'Aún no ha programado fecha de recordatorio',
                'COMPLETAR': '¿Está seguro de completar el paso con las fechas programadas?',
                '215': 'El paso se completó correctamente',
                '217': 'El paso se completó correctamente', //CERTIFICAR2.0
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se establecen las fechas de lanzamiento y envío de recordatorios para la realización de la encuesta',
                'INFORMATIVO2': 'En esta sección se establecen las fechas de envio de las encuestas Pulse Check',
                'GUARDA-OK':'La fecha se guardó satisfactoriamente',
                'OK':'OK',

              },
              'ENVIO': {
                'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                'COMPLETAR': '¿Está seguro de completar el paso?',
                '216': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se ejecuta el envío de la invitación para la realización de la encuesta a los colaboradores'
              },
              'CIERRE': {
                'NADA': 'La encuesta aún no ha concluído',
                'COMPLETAR': '¿Está seguro de completar el paso?',
                '217': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se puede consultar el progreso actual de la encuesta, así como realizar el cierre anticipado de la misma',
                'INFORMATIVO2': 'En esta sección puedes consultar el progreso actual de cada una de las encuestas Pulse Check Lanzadas'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Advertencia',
                  'INFO': 'Advertencia\n\nSe cerrará su sesión y se procederá a iniciar sesión con el centro de trabajo seleccionado.\n\n¿Confirme iniciar sesión con el centro de trabajo?',
                  'INFOODS': 'Advertencia\n\nSe cerrará su sesión y se procederá a iniciar sesión con la empresa seleccionada.\n\n¿Confirme iniciar sesión con la empresa?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Aun no cuenta con la autorizacion ',
              'BTN-ENTERADO':'ENTERADO',
              'MODAL-AUTORIZACION':'Se ha enviado tu encuesta a validar',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Parece que tenemos un problema técnico. \n\nEstamos trabajando para resolverlo.',
          '102': 'El correo introducido no está registrado',
          '103': 'La contraseña introducida es incorrecta',
          '101': 'El correo ya se encuentra registrado, por favor ingrese otro'
        }
      }
    }
};
